import AsyncStorage from '@react-native-async-storage/async-storage';
import React, { useEffect, useState } from 'react';

export const useAsyncStorage = <T>(key: string) => {
  const [store, _setStoredData] = useState<T | null | undefined>();

  const setStore = React.useCallback(
    async (value?: T) => {
      try {
        if (value === undefined) {
          await AsyncStorage.removeItem(key);
          _setStoredData(undefined);
          return;
        }
        await AsyncStorage.setItem(key, JSON.stringify(value));
        _setStoredData(value);
      } catch (e) {
        console.error(e);
      }
    },
    [key]
  );

  useEffect(() => {
    const getData = async () => {
      try {
        const storageValue = await AsyncStorage.getItem(key);
        if (storageValue !== null && storageValue !== undefined) {
          _setStoredData(JSON.parse(storageValue));
        }
      } catch (e) {
        console.error(e);
      }
    };

    getData();
  }, [key]);

  return [store, setStore] as [store: T, setStore: (value: T) => void];
};
